import { render } from "./PolicyPdf.vue?vue&type=template&id=10b6f126&scoped=true"
import script from "./PolicyPdf.vue?vue&type=script&lang=js"
export * from "./PolicyPdf.vue?vue&type=script&lang=js"

import "./PolicyPdf.vue?vue&type=style&index=0&id=10b6f126&scoped=true&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b6f126"]])

export default __exports__